export default {
  invalid: '{fieldName} is invalid',
  confirmed: 'The value of{fieldName} should equal to {target}',
  required: '{fieldName} is required'
}
